var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog, Transition } from '@headlessui/react';
import classNames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
export default function JetModal(_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, _b = _a.maxWidth, maxWidth = _b === void 0 ? '2xl' : _b, children = _a.children;
    var maxWidthClass = {
        sm: 'sm:max-w-sm',
        md: 'sm:max-w-md',
        lg: 'sm:max-w-lg',
        xl: 'sm:max-w-xl',
        '2xl': 'sm:max-w-2xl',
        '3xl': 'sm:max-w-3xl',
        '4xl': 'sm:max-w-4xl',
        '5xl': 'sm:max-w-5xl',
        '6xl': 'sm:max-w-6xl',
        '7xl': 'sm:max-w-7xl',
    }[maxWidth];
    return ReactDOM.createPortal(_jsx(Transition.Root, __assign({ show: isOpen, as: React.Fragment }, { children: _jsx(Dialog, __assign({ as: "div", static: true, className: "fixed z-[100] inset-0 overflow-y-auto", open: isOpen, onClose: onClose }, { children: _jsxs("div", __assign({ className: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }, { children: [_jsx(Transition.Child, __assign({ as: React.Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0", enterTo: "opacity-100", leave: "ease-in duration-200", leaveFrom: "opacity-100", leaveTo: "opacity-0" }, { children: _jsx(Dialog.Overlay, { className: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }) })), _jsx("span", __assign({ className: "hidden sm:inline-block sm:align-middle sm:h-screen", "aria-hidden": "true" }, { children: "\u200B" })), _jsx(Transition.Child, __assign({ as: React.Fragment, enter: "ease-out duration-300", enterFrom: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95", enterTo: "opacity-100 translate-y-0 sm:scale-100", leave: "ease-in duration-200", leaveFrom: "opacity-100 translate-y-0 sm:scale-100", leaveTo: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" }, { children: _jsx("div", __assign({ className: classNames('inline-block align-bottom bg-white rounded-lg text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:w-full', maxWidthClass) }, { children: children })) }))] })) })) })), document.body);
}
